// Strings for the read-only careplan of a Loom lead. The wording is the same as the client
// view's careplan (client.ClientDetail.Careplan). Match difficulty labels are in
// loomLead.MatchDifficulty.
export default {
  Title: 'Careplan',
  CareplanSummary: {
    Title: 'Careplan summary',
    NoCareplanSummary: 'No careplan summary',
  },
  GeneralInformation: {
    Title: 'General information',
    ClientName: 'Client name',
    NoClientname: 'No client name',
    Address: 'Address',
    NoAddress: 'No address',
    Information: 'Information',
    NoClientInformation: 'No client information',
    Notes: 'Notes',
    NoNotes: 'No notes',
  },
  MedicalHistory: {
    Title: 'Medical history',
    Medications: 'Medications',
    NoMedications: 'No medications',
    Conditions: 'Conditions',
    NoConditions: 'No conditions',
  },
  CareRoutine: {
    Title: 'Care routine',
    ClientPreferences: 'Client preferences',
    NoPreferences: 'No preferences',
    Tasks: 'Daily Tasks',
    NoTasks: 'No tasks',
  },
  CaregiverRequirements: {
    Title: 'Caregiver requirements (Admin only)',
    ScheduleRequirement: 'Schedule requirement',
    NoScheduleRequirement: 'No schedule requirement',
    MatchDifficulty: 'Match difficulty',
    NoMatchDifficulty: 'Not analyzed yet',
    RequirementChips: 'Requirement tags',
    NoRequirementChips: 'No requirements added',
  },
  ReplacementPreference: {
    Title: 'Replacement preference',
    Field: 'Replacement preference',
    Options: {
      NONE: 'NOT SET',
      FIND_REPLACEMENT: 'Find Replacement Caregiver',
      SKIP_VISIT: 'Skip Visit',
    },
  },
};
